var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.errorItems.length)?_c('ul',{staticClass:"errors-list"},_vm._l((_vm.errorItems),function(item,index){return _c('li',{key:index},[_vm._v(_vm._s(item))])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }